export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8538.b37f1883.jpg";